const getApiUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (!envUrl) return '';
  try {
    const envHost = new URL(envUrl).hostname;
    if (typeof window !== 'undefined' && window.location.hostname !== envHost) {
      return '';
    }
  } catch (e) {
    return '';
  }
  return envUrl;
};

export const API_URL = getApiUrl();
